import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store';
import api from '../utils/api';
import { toast } from 'react-toastify';

export default function Profile() {
  const { user, logout, fetchMe } = useAuthStore();
  const navigate = useNavigate();
  const [form, setForm] = useState({ firstName: user?.firstName || '', lastName: user?.lastName || '', phone: user?.phone || '' });
  const [pwForm, setPwForm] = useState({ currentPassword: '', newPassword: '', confirm: '' });
  const [loading, setLoading] = useState(false);

  if (!user) { navigate('/login'); return null; }

  const handle = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  const handlePw = (e) => setPwForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const saveProfile = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await api.put('/auth/profile', form); await fetchMe(); toast.success('Profile updated!'); }
    catch (err) { toast.error(err.response?.data?.message || 'Update failed'); }
    finally { setLoading(false); }
  };

  const changePassword = async (e) => {
    e.preventDefault();
    if (pwForm.newPassword !== pwForm.confirm) { toast.error('Passwords do not match'); return; }
    setLoading(true);
    try { await api.put('/auth/password', { currentPassword: pwForm.currentPassword, newPassword: pwForm.newPassword }); toast.success('Password changed!'); setPwForm({ currentPassword: '', newPassword: '', confirm: '' }); }
    catch (err) { toast.error(err.response?.data?.message || 'Password change failed'); }
    finally { setLoading(false); }
  };

  return (
    <div className="container" style={{ maxWidth: 760, padding: '3rem 1.5rem' }}>
      <h1 style={{ fontSize: '1.75rem', fontWeight: 800, marginBottom: '2rem' }}>My Profile</h1>

      {/* Profile info */}
      <div className="card" style={{ padding: '2rem', marginBottom: '1.5rem' }}>
        <h3 style={{ fontWeight: 700, marginBottom: '1.5rem' }}>Personal Information</h3>
        <form onSubmit={saveProfile}>
          <div className="auth-row">
            <div className="form-group">
              <label className="form-label">First Name</label>
              <input name="firstName" className="form-input" value={form.firstName} onChange={handle} required />
            </div>
            <div className="form-group">
              <label className="form-label">Last Name</label>
              <input name="lastName" className="form-input" value={form.lastName} onChange={handle} required />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Email</label>
            <input className="form-input" value={user.email} disabled style={{ background: 'var(--gray-50)', color: 'var(--gray-400)' }} />
          </div>
          <div className="form-group">
            <label className="form-label">Phone</label>
            <input name="phone" type="tel" className="form-input" value={form.phone} onChange={handle} />
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>Save Changes</button>
        </form>
      </div>

      {/* Change password */}
      <div className="card" style={{ padding: '2rem', marginBottom: '1.5rem' }}>
        <h3 style={{ fontWeight: 700, marginBottom: '1.5rem' }}>Change Password</h3>
        <form onSubmit={changePassword}>
          <div className="form-group">
            <label className="form-label">Current Password</label>
            <input name="currentPassword" type="password" className="form-input" value={pwForm.currentPassword} onChange={handlePw} required />
          </div>
          <div className="auth-row">
            <div className="form-group">
              <label className="form-label">New Password</label>
              <input name="newPassword" type="password" className="form-input" value={pwForm.newPassword} onChange={handlePw} required />
            </div>
            <div className="form-group">
              <label className="form-label">Confirm New Password</label>
              <input name="confirm" type="password" className="form-input" value={pwForm.confirm} onChange={handlePw} required />
            </div>
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>Update Password</button>
        </form>
      </div>

      <button className="btn btn-danger" onClick={() => { logout(); navigate('/'); }}>Logout</button>
    </div>
  );
}
